
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://smlvxizjanoegqeedhmw.supabase.co';
const supabaseKey = 'sb_publishable_RWtceHSW_68jvKRW9gnWlQ_TaRvrihw';

export const supabase = createClient(supabaseUrl, supabaseKey);
